import React, { useState } from 'react';
import CommonTable from './commonTable';
import SearchInput from '../common/Input/SearchInput';
import { PER_PAGE } from '../../utils/constants';
import SelectMenu from '../common/SelectMenu';

const LeaderBoardList = ({
  data,
  page,
  handlePagination,
  limit = 10,
  setPage,
  setLimit,
  header = 'All LeaderBoard'
}) => {
  const [selectedPerPage, setSelectedPerPage] = useState(
    PER_PAGE.find((p) => p.value === limit) || PER_PAGE[0]
  );
  // Leaderboard columns matching the provided image
  const columns = [
    { header: 'Name', accessor: 'name' },
    { header: 'Email', accessor: 'email' },
    { header: 'Score', accessor: 'totalScore' },
    { header: 'Rank', accessor: 'rank' }
  ];
  console.log(data);

  return (
    <div className="leaderboard-list  ">
      <div className="bg-white rounded-lg shadow p-6 m-4">
        <div className="flex flex-wrap items-center gap-6 mb-4">
          <div className="hidden sm:flex mr-3 self-center">
            <span className="self-center md:block hidden text-sm mr-2 text-shoorah-lightBlack dark:text-white">
              {'Per Page:'}
            </span>
            <div className="w-[80px]">
              <SelectMenu
                menuList={PER_PAGE}
                showLabel={false}
                defaultSelected={selectedPerPage}
                setSelectedMenu={(data) => {
                  if (setLimit) {
                    setPage(1);
                    setLimit(data.value);
                  }
                }}
              />
            </div>
          </div>
        </div>

        {data?.data?.length > 0 ? (
          <CommonTable
            columns={columns}
            data={data}
            currentPage={page}
            totalItems={data?.meta?.pagination?.totalItems}
            itemsPerPage={limit}
            pagination={true}
            onPageChange={handlePagination}
          />
        ) : (
          <p className="text-center">No data available</p>
        )}
      </div>
    </div>
  );
};

export default LeaderBoardList;
